export namespace CompanyConstants {
  export const course = ["", 'Light', 'Standard', "Special", "Trial"];
  // export const status = ["", "利用中", "退会", "更新手続き中", "入金待ち"];
  export const status = ["", "利用中", "退会", "", "入金待ち"];
}
